import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { BankingDataService } from '../banking-data.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { ConfigService } from '../../../../../core/services/config.service';

@Component({
  selector: 'itpx-banking-data-edit',
  templateUrl: './banking-data-edit.component.html',
  styleUrls: ['./banking-data-edit.component.css']
})
export class BankingDataEditComponent implements OnInit {

    private details: any;
    private sub: Subscription;
    private saveUrl: string;
    private cancelRoute: string = '/agora/account-data/banking-data';
    private fields: any[];
    private id: string;

    constructor(
            private bankingDataService: BankingDataService,
            private configService: ConfigService,
            private notificationService: NotificationService,
            private router: Router,
            private route: ActivatedRoute
    ) { }

    ngOnInit() {

            this.sub = this.route.params.subscribe(params => {
                this.id = params['id'];
                this.fields = this.bankingDataService.getEditFields();
                this.bankingDataService.getBankingDataDetails(this.id)
                    .subscribe(
                        body => {
                            this.details = <any>body['data'];
                        }
                    );
            });
            this.saveUrl = this.configService.get('server').url + this.configService.get('endpoints').agora.bankingData.edit.api;
    }

    private onSaveFinished(event) {
            this.router.navigate(['/agora/account-data/banking-data/:id/details', { id: this.id }]);
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/banking-data/edit/banking-data-edit.component.ts